import React, {useContext} from 'react';

import {Radio} from "@mui/material";

import RadioButtonIcon from "components/icons/RadioButtonIcon";

import InventoryName from "./InventoryName";

import {SidebarContext} from "../../../../../SidebarContext";

function InventoryList(props) {
    const {currentInventory, memberInventories, setCurrentInventory, isMobile, closeSidebar} = useContext(SidebarContext);

    if (!currentInventory || !memberInventories) {
        return null;
    }

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            width: isMobile ? '100%' : '200px'
        }}>
            {memberInventories.map((inventory) => (
                <div
                    key={inventory.id}
                    onClick={() => {
                        setCurrentInventory(inventory);
                        closeSidebar();
                    }}
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '8px 0px 8px 8px',
                        cursor: 'pointer'
                    }}
                >
                    <InventoryName name={inventory.name} noIcon />
                    <Radio
                        icon={<RadioButtonIcon />}
                        checkedIcon={<RadioButtonIcon checked />}
                        checked={inventory.id === currentInventory.id}
                    />
                </div>
            ))}
        </div>
    );
}

export default InventoryList;
